export const eventBind = "bans-bind"
